import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Field, Form as FinalForm } from 'react-final-form';
import { Button, Form, Label, Select } from 'semantic-ui-react';
import ValidatedFormInput from 'components/ValidatedFormInput';
import { updateDiscountBottomPrice } from 'state/discountSettings/actions';
import PropTypes from 'prop-types';

const BottomPriceForm = props => {
  const { dispatch, bottomPriceIsLoading } = props;
  const [bottomPriceType, setBottomPriceType] = useState('annually');

  const onSubmitBottomPrice = ({ bottomPrice }) => {
    dispatch(updateDiscountBottomPrice(bottomPrice, bottomPriceType));
  };

  const options = [
    { key: 'annually', text: 'annually', value: 'annually' },
    { key: 'monthly', text: 'monthly', value: 'monthly' },
  ];

  return (
    <FinalForm
      onSubmit={onSubmitBottomPrice}
      render={({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Field
            name="bottomPrice"
            component={ValidatedFormInput}
            label="Bottom Price"
            required
            action
          >
            <Label>Bottom Price</Label>
            <input name="bottomPrice" />
            <Select
              compact
              options={options}
              defaultValue="annually"
              onChange={(e, { value }) => setBottomPriceType(value)}
            />
            <Button content="Submit" loading={bottomPriceIsLoading} primary />
          </Field>
        </Form>
      )}
    />
  );
};

const mapStateToProps = ({ discountSettings }) => ({
  bottomPriceIsLoading: discountSettings.discountSettings.bottomPriceIsLoading,
});

BottomPriceForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  bottomPriceIsLoading: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(BottomPriceForm);
